<template>
  <div id="tlk-abbonamento">
    <FormStep v-if="!reference && !loading && !closed"></FormStep>
    <Loader v-if="loading" />
  </div>
</template>

<script>
import FormStep from '@/components/FormStep';
import Loader from '@/components/Loader';
import { isNil, isEmpty } from "lodash";
import { getQueryParams } from '@/utils/func';
import { getData } from "@/api/ajax";
// import { mapActions } from 'vuex';


export default {
	name: 'App',
	mixins: [getData],
	data() {
		return {
			loading: false,
			errorLoading: false,
			closed: false,
			reference: false
		}
	},
	components: {
		FormStep,
		Loader
	},
	beforeCreate() {
	},
	created() {
		this.log('abbonamentoDetails', !isNil(this.abbonamentoDetails));
		// se è modifica carico dati abbonamento in store
		if ( this.isUpdate && !this.disableUpdate ) {

			const abbonamentoDetails = JSON.parse(this.abbonamentoDetails);

			this.log('carico dati abbonamento preso da endpoint');

			if ( isNil(abbonamentoDetails.subscription) || isNil(abbonamentoDetails.variation) )
				this.errorLoading = true;

			// registro store abbonamento
			this.$store.commit("setStore", abbonamentoDetails);
			// registro store backup products selected
			if(!isNil(abbonamentoDetails.products) || !isEmpty(abbonamentoDetails.products) ){
				this.$store.commit("setBackupProductsSelected", abbonamentoDetails.products);
				this.log('backupProductsSelected', this.$store.getters.backupProductsSelected);
			}
			
			this.log('loaded abbonamento', this.$store.getters.abbonamento, this.$store.getters.subscription, this.$store.getters.variation);
			// momentaneo blocco modifica
			if ( this.disableUpdate || this.errorLoading){
				this.$store.commit("setStep", 6);
				// this.GTM_trackEvent('Modifica disabilitata', 'Step init');
			}else{
				// this.GTM_trackEvent('Modifica abbonamento', 'Step init');
			}

		}
	},
	async beforeMount(){	
		this.loading = true;
		
		// altrimenti carico da test o utente
		if ( !this.isUpdate || this.disableUpdate ) {
			// --- TEST
			// caricamento dati provenienti da form test
			const form_id = getQueryParams('form_id');
			const entry_id = getQueryParams('entry_id');
			const obiettivi_id = getQueryParams('obiettivi_id');
			const allergeni_id = getQueryParams('allergeni_id');
			this.log('gravity form ' + form_id);
			this.log('gravity form entry ' + entry_id);
			this.log('gravity form obiettivi ' + obiettivi_id);
			this.log('gravity form allergeni ' + allergeni_id);
			if( !isNil(form_id) && 
				!isNil(entry_id) &&
				!isNil(obiettivi_id) &&
				!isNil(allergeni_id)
			){
				try {
					const test_data = await this.getTestData(form_id, entry_id, obiettivi_id, allergeni_id);
					let test_obiettivi = test_data.data.obiettivi;
					let test_allergeni = test_data.data.allergeni;
					this.$store.commit("setStore", {obiettivi: test_obiettivi, allergeni: test_allergeni});
					this.log('load test', test_data.data);
					//this.GTM_trackEvent('Creazione abbonamento da test', 'Step init');
				} catch (e) {
					this.log('errore dato da test',e);
				}
			}else{
				this.log('nessuno dato da test, provo a prenderlo da utente');
			}
			// --- USER
			// carico dati dall'utente se non recuperati da test
			if( isEmpty(this.$store.getters.obiettivi_active) || isEmpty(this.$store.getters.allergeni_active) ) {
				try {
					const user_data = await this.getUserData(form_id, entry_id, obiettivi_id, allergeni_id);
					let user_obiettivi = user_data.data.obiettivi;
					let user_allergeni = user_data.data.allergeni;
					this.$store.commit("setStore", { obiettivi: user_obiettivi, allergeni: user_allergeni });
					this.log('load user', user_data.data);

				} catch (e) {
					this.log('errore dato da user', e);
				}
			}	
		}

		// carica i dati master
		try {
			const subscriptions = await this.getSubscriptions();
			this.log('load master subscriptions', subscriptions.data);
			
			const obiettivi = await this.getObiettivi();
			this.log('load master obiettivi', obiettivi.data);

			const allergeni = await this.getAllergeni();
			this.log('load master allergeni', allergeni.data);

			// setto i master nello store
			this.$store.commit("setSubscriptions", subscriptions.data);
			this.$store.commit("setObiettivi", obiettivi.data);
			this.$store.commit("setAllergeni", allergeni.data);

			// filtro e setto variation nello store
			const subid = this.$store.getters.subscription;
			const subs = this.$store.getters.subscriptions;
			const sub = subs.filter(subscription => subscription.id == subid);
			if ( !isEmpty(sub) )
				this.$store.commit("setVariations", sub[0].variations);
			

			// se è modifica e abilitato salto step subscribtions/variations e ha caricato correttamente l'abbonamento
			if ( this.isUpdate && !this.disableUpdate && !this.errorLoading )
				this.$store.commit("setStep", 2);

			// fine loading spinner
			this.loading = false;

		} catch (e) {
			this.loading = false;
			this.errorLoading = true;
			this.log('errore dati beforeMount',e);
		}
	},
	methods: {
		// ...mapActions([
		// 	'init'
		// ])
	}
}
</script>

<style lang="scss" scoped>
	#tlk-abbonamento::v-deep {
		// @import "style";
		@import "../../../themes/tls-theme/src/scss/variables";
		.btn{
			transition: all 0.6s ease-in;
		}
		.active:not(.nav-link) {
			border: 1px solid $primary;
		}
		.not-active{
			border: 1px solid $secondary;
		}
		.unlimited{
			color: $primary;
		}
	}
</style>
